import { useMemo } from "react";
import "../../../shared/lib/store/createAppApi.js";
import "../../../shared/lib/store/createAppAsyncThunk.js";
import "../../../shared/lib/store/createAppSelector.js";
import "../../../shared/lib/store/createAppSlice.js";
import "redux";
import "../../../shared/lib/store/hooks/useAppDispatch.js";
import { useAppSelector } from "../../../shared/lib/store/hooks/useAppSelector.js";
import "../../../shared/lib/store/hooks/useAppStore.js";
import { useGetSpecificationsQuery } from "../api/api.js";
import "../model/selectors/selectOptionGroupsParameters.js";
import "../model/selectors/selectSpecificationGroupsParameters.js";
import { selectSpecificationsParameters } from "../model/selectors/selectSpecificationsParameters.js";
const useGetVehiclesSpecifications = () => {
  var _a;
  const specificationsParameters = useAppSelector(selectSpecificationsParameters);
  const queryResult = useGetSpecificationsQuery(specificationsParameters);
  const specificationsMap = useMemo(() => {
    var _a2;
    if (!((_a2 = queryResult.data) == null ? void 0 : _a2.items)) {
      return;
    }
    return queryResult.data.items.reduce(
      (acc, item) => {
        return {
          ...acc,
          [item.id]: item
        };
      },
      {}
    );
  }, [(_a = queryResult.data) == null ? void 0 : _a.items]);
  return useMemo(
    () => ({
      ...queryResult,
      preparedData: {
        specificationsMap
      }
    }),
    [specificationsMap, queryResult]
  );
};
export {
  useGetVehiclesSpecifications
};
